export enum BankAccountsActionTypes {
  REQUEST_BANK_ACCOUNTS_START = '@@bank-accounts/REQUEST_BANK_ACCOUNTS_START',
  REQUEST_BANK_ACCOUNTS_SUCCESS = '@@bank-accounts/REQUEST_BANK_ACCOUNTS_SUCCESS',
  REQUEST_BANK_ACCOUNTS_FAILED = '@@bank-accounts/REQUEST_BANK_ACCOUNTS_FAILED',
  SET_SORT_PARAMS = '@@bank-accounts/SET_SORT_PARAMS',
}
